import ko from "knockout";

import logger from "../logger";
import cultureAwarePersonIdValidator from "../common/cultureAwarePersonIdValidator";

import { MaybeObservable } from "../interfaces/MaybeObservable";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutPunchesFilters {
        personIdFormat(valueObs: MaybeObservable<string>): string;
    }
}

ko.filters.personIdFormat = function (valueObs: MaybeObservable<string>) {
    const rawValue = ko.unwrap(valueObs);
    try {
        return cultureAwarePersonIdValidator.doTransform(rawValue);
    } catch (e) {
        logger.error("personId filter error:", e);
        return rawValue; // Return the original value if transformation fails
    }
};
